/**
 *
 * @module telemetryEvent
 *
 */

/**
 *
 * @interface TelemetryEvent
 *
 */
export default class TelemetryEvent {

    /**
     *
     * @access private
     * @returns {SDK.Services.Internal.Telemetry.TelemetryPayload} JSONSerializable payload
     *
     */
    getPayload() {

        return new Promise((resolve) => {
            return resolve(new Error('TelemetryEvent#getPayload - not-implemented'));
        });

    }

}



// WEBPACK FOOTER //
// ./src/internal/telemetry/telemetryEvent.js